module.exports = __webpack_public_path__ + "static/bag_of_holding-da85f4487016d87bf488c0f9901dfce8.jpeg";